import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject, input, output } from '@angular/core';
import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { NzBreadCrumbComponent } from 'ng-zorro-antd/breadcrumb';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { FikoYTKokBilesenComponent } from '../../../../kok-bilesen/kok-bilesen.component';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzInputModule } from 'ng-zorro-antd/input';
import { FormsModule } from '@angular/forms';
import { FikoYTDiyalogKullaniciMenuComponent } from '../fikoyt-diyalog-kullanici-menu/fikoyt-diyalog-kullanici-menu.component';
import { BaslikPortalService } from './baslik-portal.service';
import { NgTemplateOutlet } from '@angular/common';


@Component({
  selector: 'fikoyt-uygulama-baslik',
  standalone: true,
  imports: [FormsModule, NgOptimizedImage, NzBreadCrumbComponent, NzPopconfirmModule, NzInputModule, NzTooltipModule, NzTypographyModule, FikoYTDiyalogKullaniciMenuComponent, NgTemplateOutlet],
  templateUrl: "./fikoyt-uygulama-baslik.component.html",
  styleUrl: "./fikoyt-uygulama-baslik.component.less",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FikoYTUygBaslikComponent extends FikoYTKokBilesenComponent {

  baslikPortal = inject(BaslikPortalService);

  readonly solSimgeTiklandi = output<void>();
  readonly kullaniciSimgeTiklandi = output<void>();
  readonly logoTiklandi = output<void>();
  readonly altBaslikTiklandi = output<void>();
  readonly altBaslik = input<any>({
    ismi: "baslik",
    turu: "Yazı",
    degeri: "FikoYT",
    ayarlar: {
      solSimge: "🏡"
    }
  });
  readonly yolGoster = input<boolean>(false);
  new: any;

  form: any = {};
  // Not: FikoYT.degisti subscription zaten FikoYTKokBilesenComponent tarafindan yonetiliyor.
  // Cifte subscription kaldirildi — gereksiz CD tetiklemesini onler.

  constructor() {
    super();
  }

  tiklandiCikisYap() {
    this.FikoYT.kimlik.cikisYap().then(() => {

    })
  }
}
